import { getLiveTagValue } from "@/features/datapoints/api/getLiveTagValue.ts"
import { getTagIntervals } from "@/features/datapoints/api/getTagIntervals.ts"
import type { DataPointIntervalRequest, TagPath } from "@/types/dataPointTypes.ts"

import { getGasDayRemaining } from "../../util/getGasDayRemaining.ts"
import { getGasDayStart } from "../../util/getGasDayStart.ts"

import type { DailyDisplayData } from "../../types/dailyDisplayTypes.ts"

export const getDailyData = async (): Promise<DailyDisplayData> => {
  const salesMeter: TagPath = {
    tag: "sales/sales gas flow",
    historyProvider: "PLTH_Samsara_Imports_Historical_Local",
    driver: "ignition-plth-srv2025:samsara_imports",
  }

  const salesQuality: TagPath = {
    tag: "sales/sales methane",
    historyProvider: "PLTH_Samsara_Imports_Historical_Local",
    driver: "ignition-plth-srv2025:samsara_imports",
  }

  const flareMeter: TagPath = {
    tag: "flare/flare flow",
    historyProvider: "PLTH_Samsara_Imports_Historical_Local",
    driver: "ignition-plth-srv2025:samsara_imports",
  }

  const start = getGasDayStart("America/Chicago", 7)
  const end = new Date()
  const interval = Math.round((end.getTime() - start.getTime()) / 1000) + 1

  const averageRequest: DataPointIntervalRequest = {
    start,
    end,
    interval,
    aggMode: "Average",
  }
  const responses = await Promise.all([
    getTagIntervals(salesMeter, averageRequest),
    getTagIntervals(salesQuality, averageRequest),
    getTagIntervals(flareMeter, averageRequest),
    getLiveTagValue("PLTH_Samsara_Imports/Sales/Sales Gas Flow"),
    getLiveTagValue("PLTH_Samsara_Imports/Sales/Sales Methane"),
  ])

  const [salesFlow, salesMethane] = [responses[3], responses[4]]

  const gasToPipeline =
    ((responses[0][0].value || 0) / 86400) * interval * ((responses[1][0].value || 0) / 100) * 1.01

  const gasFlared = ((responses[2][0].value || 0) / 86400) * interval

  const remainingHours = getGasDayRemaining("America/Chicago", 7)

  const outletSCFM = salesFlow / 1.44
  const outletCH4 = salesMethane / 100

  const projection = gasToPipeline + (remainingHours * 60 * outletSCFM * outletCH4 * 1.01) / 1000

  return {
    gasToPipeline,
    gasFlared,
    runTime: 0,
    remainingHours,
    projection,
  }
}
